import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import React from "react";

export interface StoryblokComponentData {
  pageData: SbBlokData;
  version: "draft" | "published";
}

interface SbPageData extends SbBlokData {
  body: SbBlokData[];
}

interface PageProps {
  blok: SbPageData;
  version: "draft" | "published";
}

const Page: React.FunctionComponent<PageProps> = ({ blok, version }) => {
  const data: StoryblokComponentData = { pageData: blok, version };

  return (
    <main {...storyblokEditable(blok)}>
      {blok.body?.map((nestedBlok) => (
        <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} data={data} />
      ))}
    </main>
  );
};

export default Page;
